import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Service } from "../../shared/services/service";
import { Funcoes } from "../../funcoes";

@Injectable()
export class ClientesTestesSoproService extends Service {

  protected url: string = this.dominio + "/cli/clientes-usuarios/meus-testes-sopro/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  // busca lista de clientes visiveis para o usuario logado
  getVisibilidades() {
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + 'visibilidades/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  getById(id) {
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id + '/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  getPdfs(id) {
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id + '/pdfs/', { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  getPdfUrl(id, lang?: string) {
    let langParam = lang ? '&lang=' + lang : '';
    return this.dominio + '/cli/clientes-usuarios/meus-testes-sopro/' + id + '/pdf/?tk=' + localStorage.getItem('token') + langParam;
  }

  getPdfAnexoUrl(idTeste, idPdf) {
    return this.dominio + '/cli/clientes-usuarios/meus-testes-sopro/' + idTeste + '/pdfs/' + idPdf + '/?tk=' + localStorage.getItem('token');
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/meus-testes-sopro/clientes-testes-sopro.service.ts